module.exports = __webpack_public_path__ + "static/media/Hydraulics-Cylinders-Comparison@3x-100.41f4d95e.png";